import SHeading from '@/components/atoms/SHeading';
import ExteriorBoothDesign from '@/components/molecules/ExteriorBoothDesign';
import FrameDesign from '@/components/molecules/FrameDesign';
import PhotoFilter from '@/components/molecules/PhotoFilter';
import UserInterFaceDesign from '@/components/molecules/UserInterFaceDesign';
import React from 'react'
import { useTranslation } from "react-i18next";

const HighlyCusTomization = () => {
  const { t } = useTranslation();

  return (
    <div className="bg-white p-8 w-full mt-8 rounded-3xl">
      <SHeading
        text={t("home.highly_customizable")}
        tAlign="center"
      />
      <div className="flex flex-col md:flex-row gap-8 mt-6 w-full">
        <PhotoFilter className="w-full mx-auto md:w-[70%] " />
        <FrameDesign />
      </div>
      <UserInterFaceDesign />
      <ExteriorBoothDesign />
    </div>

  )
}

export default HighlyCusTomization;